import { m } from "framer-motion";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import ProgressBar from "components/progress-bar";
import Logo from "../logo";
import useResponsive from "hooks/useResponsive";
import useAppTheme from "hooks/useAppTheme";
import { NAVBAR_CONFIG } from "configs/app.config";
import { useLocation } from "react-router";
import useAuth from "hooks/useAuth";
import { BorderLinearProgress } from "../loaders/style";

const StyledRoot = styled("div")(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 9998,
  width: "100%",
  height: "100%",
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `radial-gradient(82.62% 99.48% at 17.38% 61.42%, #677DE5 4.96%, #7862BB 53.66%, #A85EAF 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
  `,
}));

export default function RouterLoadingScreen() {
  const isDesktop = useResponsive("up", "lg");
  const { themeLayout } = useAppTheme();
  const { pathname } = useLocation();
  const { isInitialized } = useAuth();

  const size = (themeLayout === "vertical" && NAVBAR_CONFIG.DASHBOARD_WIDTH) || 128;
  const isDashboard = isInitialized && pathname.includes("/auth") && isDesktop;

  return (
    <>
      <ProgressBar />
      <StyledRoot
        sx={{
          ...(isDashboard && {
            width: `calc(100% - ${size}px)`,
            ...(themeLayout === "horizontal" && {
              width: 1,
              height: `calc(100% - ${size}px)`,
            }),
          }),
        }}
      >
        {isDashboard ? (
          <>
            <m.div
              animate={{
                scale: [1, 0.9, 0.9, 1, 1],
                opacity: [1, 0.48, 0.48, 1, 1],
              }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                repeatDelay: 1,
                repeat: Infinity,
              }}
              style={{ top: "30%", left: "40%", position: "absolute" }}
            >
              <Logo disabledLink sx={{ width: 64, height: 64 }} />
            </m.div>
            <Box sx={{ width: "70%" }}>
              <BorderLinearProgress />
            </Box>
          </>
        ) : (
          <>
            <m.div
              animate={{
                scale: [1, 0.9, 0.9, 1, 1],
                opacity: [1, 0.48, 0.48, 1, 1],
              }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                repeatDelay: 1,
                repeat: Infinity,
              }}
              style={{ top: "30%", left: "40%", position: "absolute" }}
            >
              <Logo disabledLink sx={{ width: 64, height: 64 }} />
            </m.div>
            <Box sx={{ width: "70%" }}>
              <BorderLinearProgress />
            </Box>
          </>
        )}
      </StyledRoot>
    </>
  );
}
